export default {

    tableWrapperId: 'bundle-pricingtable-wrapper-'+Math.random().toString(36).substr(2, 16),
    amountDesktop: 1,
    amountTablet: 1,
    amountPhone: 1,


    tables: [
        {
            tableId: 'bundle-pricingtable-'+Math.random().toString(36).substr(2, 16),
            planName: 'Plan Name',
            price: '700',
            currency: '$',
            link: 'https://www.appjustable.com',
            linkText: 'Buy Now',
            target: '_blank',

            useCustomFontPlan: false,
            customFontNamePlan: "'Helvetica Neue', sans-serif",
            customFontWeightPlan: "400",
            customFontStylePlan: 'normal',

            fontFamilyPlan: 'Roboto', // in applyfont: fontfamily
            fontWeightPlan: '400', // in applyfont: fontweight
            fontStylePlan: 'normal', // in applyfont: fontstyle
            fontGoogleLoadPlan: 'Roboto:400', // in applyfont: selector
            fontSizePlan: 17,
            colorPlan: '#fff',
            bgPlan: '#333',


            useCustomFontPrice: false,
            customFontNamePrice: "'Helvetica Neue', sans-serif",
            customFontWeightPrice: "100",
            customFontStylePrice: 'normal',

            fontFamilyPrice: 'Roboto',
            fontWeightPrice: '400',
            fontStylePrice: 'normal',
            fontGoogleLoadPrice: 'Roboto:400',
            fontSizePrice: 30,
            colorPrice: '#333',

            useCustomFontItem: false,
            customFontNameItem: "'Helvetica Neue', sans-serif",
            customFontWeightItem: "400",
            customFontStyleItem: 'normal',

            fontFamilyItem: 'Roboto',
            fontWeightItem: '400',
            fontStyleItem: 'normal',
            fontGoogleLoadItem: 'Roboto:400',
            fontSizeItem: 14,
            colorItem: '#777',
            bgItem: '#fafafa',

            colorIcon: '#f65f47',
            fontSizeIcon: 12,
            hideIcon: true,

            useCustomFontCurrency: false,
            customFontNameCurrency: "'Helvetica Neue', sans-serif",
            customFontWeightCurrency: "400",
            customFontStyleCurrency: 'normal',

            fontFamilyCurrency: 'Roboto',
            fontWeightCurrency: '400',
            fontStyleCurrency: 'normal',
            fontGoogleLoadCurrency: 'Roboto:400',
            fontSizeCurrency: 14,
            colorCurrency: '#777',
            alignCurrency: 'super',


            useCustomFontButton: false,
            customFontNameButton: "'Helvetica Neue', sans-serif",
            customFontWeightButton: "400",
            customFontStyleButton: 'normal',

            fontFamilyButton: 'Roboto',
            fontWeightButton: '400',
            fontStyleButton: 'normal',
            fontGoogleLoadButton: 'Roboto:400',
            fontSizeButton: 14,
            colorButton: '#fff',
            bgButton: '#f65f47',

            items: [
                {
                    name: 'item 1 included',
                },
                {
                    name: 'item 2 included',
                },
                {
                    name: 'item 3 included',
                }
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/pricingtablesettings.js